<div class="container-fluid">
    <div class="textpages">
        <h1>{{ page.name }}</h1>
        <p v-html="page.content"></p>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/components/pages/textpages.tpl.html